// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VB_p","icon":"styles_icon__2dQ1l"};